module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-form-row"
  }, [(_vm.label) ? _c('label', {
    staticClass: "uk-form-label",
    attrs: {
      "for": _vm.name
    }
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "uk-form-controls"
  }, [(_vm.icon) ? _c('uk-icon-field', {
    attrs: {
      "icon": _vm.icon
    }
  }, [_vm._t("default")], 2) : _vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-be18a0e4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UkFormRow.vue
// module id = 301
// module chunks = 2